const devolvemeLaEdad = (dato) => {
    // Verificar si el dato está vacío
    if (!dato) {
      return "-"; // Si está vacío, devolver -
    }
  
    const fechaNacimiento = new Date(dato); // Convertir el string en un objeto Date
    const fechaActual = new Date(); // Obtener la fecha actual
  
    let edad = fechaActual.getFullYear() - fechaNacimiento.getFullYear(); // Calcular la diferencia en años
    const mesActual = fechaActual.getMonth(); // Mes actual
    const mesNacimiento = fechaNacimiento.getMonth(); // Mes de nacimiento
  
    // Si el mes actual es antes del mes de nacimiento, restamos un año
    if (mesActual < mesNacimiento || (mesActual === mesNacimiento && fechaActual.getDate() < fechaNacimiento.getDate())) {
      edad--;
    }
  
    return edad; // Retornar la edad calculada
  };
  export default devolvemeLaEdad